<template>
  <sidebar-items-list
      :api-url="apiUrl"
      :back-to="{ name: 'projects.components.show', params: { projectId, componentId } }"
      :header="$t('Rooms')"
      model-type="room"
  >
    <template #newItemFormAppend="{newItem}">
      <b-form-group
          :invalid-feedback="newItem.errors.get('height')"
          :description="$t('Leave empty to apply floor height')"
          :label="$t('Height')"
          :state="newItem.errors.has('height') ? false : null"
          label-for="newItemHeight"
      >
        <b-input-group append="m">
          <b-form-input
              id="newItemHeight"
              v-model="newItem.height"
              :state="newItem.errors.has('height') ? false : null"
              min="0"
              name="height"
              step="0.001"
              type="number"
          />
        </b-input-group>
      </b-form-group>
    </template>
  </sidebar-items-list>
</template>
<script>
import SidebarItemsList from "@/components/SidebarItemsList";

export default {
  name: 'Rooms',
  components: {SidebarItemsList},
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
    componentId: {
      type: [Number, String],
      required: true,
    },
    floorId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    apiUrl() {
      return `/api/projects/${this.projectId}/components/${this.componentId}/floors/${this.floorId}/rooms`;
    },
  },
};
</script>
